module.exports = __webpack_public_path__ + "static/assets/f91f19f2b7e645daac51be1b15d573ae.svg";